<script setup lang="ts">
    import { __ } from '../stores/expressions';
    import { CircleAlertIcon } from '@lucide/vue';
</script>

<template>
    <div
        class="flex items-center fixed w-full top-0 left-0 justify-center h-screen p-4 sm:p-8 pl-16 sm:pl-24"
    >
        <div
            class="rounded-lg bg-white p-8 shadow-md w-full self-stretch flex items-center justify-center relative"
        >
            <div class="text-center w-full max-w-96">
                <div class="w-32 mx-auto mb-4 text-primary-carrot/10">
                    <CircleAlertIcon class="w-full h-full" />
                </div>
                <h2 class="heading-lg mb-2">
                    {{ __('not-found') }}
                </h2>
                <p class="text-body">
                    {{ __('not-found-description') }}
                </p>
            </div>
        </div>
    </div>
</template>
